import { useState } from 'react';

import { IconPinned } from '@tabler/icons-react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { cn } from '@/utils/tailwind';

import {
  isConversationPinnedAtomFamily,
  renamingConversationIdAtom,
} from '../state';

import HistoryItemMenu from './HistoryItemMenu';

import {
  currentConversationIdAtom,
  historyDrawerOpenAtom,
  renameConversation,
} from '@/routes/smart-search/state';
import { StoredConversation } from '@/routes/smart-search/types';

interface HistoryItemProps {
  conversation: StoredConversation;
}

const HistoryItem: React.FC<HistoryItemProps> = ({ conversation }) => {
  const [hover, setHover] = useState(false);
  const [titleRenaming, setTitleRenaming] = useState(conversation.title);

  const setCurrentConversationId = useSetAtom(currentConversationIdAtom);
  const setHistoryDrawerOpen = useSetAtom(historyDrawerOpenAtom);
  const isPinned = useAtomValue(
    isConversationPinnedAtomFamily(conversation.id),
  );
  const [renamingConversationId, setRenamingConversationId] = useAtom(
    renamingConversationIdAtom,
  );
  const isRenaming = renamingConversationId === conversation.id;

  return (
    <div
      className={cn(
        'hover:bg-base-2 flex items-center justify-between gap-2 rounded-lg px-2! py-1! transition-colors',
        isRenaming && 'bg-base-2',
      )}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {isRenaming ? (
        <input
          value={titleRenaming}
          onChange={e => setTitleRenaming(e.target.value)}
          onFocus={e => e.target.select()}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              setRenamingConversationId(undefined);
              renameConversation(conversation.id, titleRenaming);
            }
          }}
          onBlur={() => {
            setRenamingConversationId(undefined);
            renameConversation(conversation.id, titleRenaming);
          }}
          className="w-full min-w-0 flex-1 outline-none!"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
      ) : (
        <button
          type="button"
          className="text-variant-body1 flex min-w-0 flex-1 cursor-pointer items-center gap-2 text-left"
          onClick={() => {
            setCurrentConversationId(conversation.id);
            setHistoryDrawerOpen(false);
          }}
        >
          <p className="min-w-0 flex-1 truncate">{conversation.title}</p>
          {isPinned && <IconPinned className="shrink-0" size={20} />}
        </button>
      )}
      {!isRenaming && hover && (
        <div className="flex shrink-0 items-center">
          <HistoryItemMenu conversation={conversation} />
        </div>
      )}
    </div>
  );
};

export default HistoryItem;
